import { AxiosError } from "axios";
import type { ApiErrorResponse } from "@/types";

/** Extract a human-readable message from an Axios/API error for display in the UI. */
export function extractErrorMessage(error: unknown): string {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    if (data?.message) {
      return data.message;
    }
    if (error.response?.status === 422 && data?.details) {
      return "Please check the highlighted fields and try again.";
    }
    if (error.message) {
      return error.message;
    }
  }
  return "An unexpected error occurred. Please try again.";
}
/** Extract the backend's machine-readable error_code (e.g. "UNVERIFIED_ACCOUNT")
 * for callers that need to branch on it -- distinct from the human-readable
 * message `extractErrorMessage` returns. */
export function getErrorCode(error: unknown): string | undefined {
  if (error instanceof AxiosError) {
    const data = error.response?.data as ApiErrorResponse | undefined;
    return data?.error_code;
  }
  return undefined;
}
